// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"551ebe2e","453":"dd163abf","617":"272cb2e7"}[chunkId] + ".chunk.js";
};